
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyFlexbox as SkyFlexboxElement } from '@sky.ui/core/sky-flexbox';
 
 
 
 

 
 export const SkyFlexbox = createComponent({
   displayName: 'SkyFlexbox',
   react: React,
   tagName: 'sky-flexbox',
   elementClass: SkyFlexboxElement,
   events: {
     
     onSlotchange: 'slotchange' as EventName<Event>,
   }
  });
export type * from '@sky.ui/core/sky-flexbox';
